/* eslint-disable no-undef */
import Vue from "vue";
import router from "../router";
import axios from "axios";
import store from "@/store";

const actions = {
	setAjaxProducts({ commit }) {
		commit("setCategoriesProducts", wpData.categoryData);
	},
	calculatePrice(context, productId) {
		const product = context.state.products.find((p) => p.id == productId);
		var price = 0;
		if (product.onsale) {
			let sale = context.getters.getSale(productId);
			let indexOfSale = context.state.sales.indexOf(sale);
			let products = Object.values(sale.products);
			let quantity = 0;
			products.map(function (p) {
				let find = context.state.added.find((pr) => pr.id == p);
				if (typeof find != "undefined") {
					quantity += find.quantity;
				}
			});
			if (context.state.sales[indexOfSale].used <= parseInt(context.state.sales[indexOfSale].limit)) {
				for (let index = 1; index <= quantity; index++) {
					if (sale.products_buy_quantity % index == 0) {
						price = price + parseFloat(sale.price);
						context.state.sales[indexOfSale].used++;
					}
				}
			}
			return price;
		} else {
			if ((product.type === "both" || product.type === "unitaskg") && product.selected === "unit") {
				return parseFloat(product.quantity * product.weight * product.price).toFixed(2);
			}
			return parseFloat(product.quantity * product.price).toFixed(2);
		}
	},
	getSale(context, productId) {
		if (productId) {
			let sale = context.state.sales.find((s) => {
				let products = Object.values(s.products);
				products = products.filter((p) => p > 0);
				if (Array.isArray(products) && products.length > 0) {
					if (products.includes(productId)) {
						return s;
					}
				}
			});
			if (sale) {
				return sale;
			}
		}
		return null;
	},
	getSales({ commit }) {
		commit("setSales", JSON.parse(wpData.all_sales));
		return;
		// axios({
		//   method: "GET",
		//   url: wpData.all_sales,
		//   headers: {
		//     "X-Requested-With": "XMLHttpRequest"
		//   }
		// }).then(resposne => {
		//   commit("setSales", resposne.data);
		// }).catch(e => console.log(e));
	},
	getBogoSales({ commit }) {
		if (wpData.bogo_sales.length) {
			commit("setBogoSales", JSON.parse(wpData.bogo_sales));
		}
	},
	getCities({ commit }) {
		axios({
			method: "GET",
			url: ajaxUrl + "?action=getCities",
		})
			.then((res) => commit("setCities", res.data.data))
			.catch((e) => console.log(e));
	},
	// getSlots
	getShipSlots({ commit, state }, [city_id, per]) {
		commit("setShipSlots", []);
		let orderAsEmail = state.orderAs ? state.orderAs.email : state.userLoggedInfo.email;

		let include_slot = "";
		if (state.orderEdit && typeof state.orderEditMeta == "object") {
			include_slot = {
				date: state.orderEditMeta.meta.jckwds_date[0],
				slot_index: state.orderEditMeta.meta.jckwds_slotIndex[0],
			};
		}

		let slot_service = "quattro-shipping";

		if (state.emergencyMode.officecore) {
			try {
				window.dataLayer.push({
					event: "ga_event",
					category: "checkout",
					action: "get_slots",
					label: "disabled",
				});
			} catch (err) {}


			let slots = {};
			let hoursTemplate = [
				{
					id: 0,
					hour: "12:00 - 21:00",
					employee_number: "290",
				},
			];
			let dayNames = [
				"ראשון", // Sunday
				"שני", // Monday
				"שלישי", // Tuesday
				"רביעי", // Wednesday
				"חמישי", // Thursday
				"שישי", // Friday
			];
			let currentDate = new Date();

			for (let day = 0; day <= 6; day++) {
				let nextDay = day === 0 && currentDate.getHours() >= 13 ? 1 : 0;

				currentDate.setDate(currentDate.getDate() + (currentDate.getDay() === 6 ? 1 : nextDay ));
				let dateKey = currentDate.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: '2-digit' });
				let dayName = dayNames[currentDate.getDay()];

				// Generate data for each date
				slots[dateKey] = {
					day: dayName,
					date: dateKey,
					hours: hoursTemplate.map((h, index) => ({ ...h, id: index })),
				}
				if (dayName==='שישי') {
					slots[dateKey].hours[0].hour = "12:00 - 17:00";
				}
				currentDate.setDate(currentDate.getDate() + 1);
			}

			// Output the result
			//console.log('slots', slots);
			commit("setShipSlots", slots);
		}
		else {
			try {
				slot_service = wpData.globalOptions.office_core_settings.slot_service;
				if (!slot_service) {
					slot_service = "quattro-shipping";
				}
			} catch (e) {}

			// Handle permanent orders
			if ((per !== "undefined" && per) || per == "true") {
				let endpoint = ajaxUrl + "?action=getPermenantSlots&id=" + city_id + "&orderAs=" + orderAsEmail;
				if (slot_service === "office-core") {
					endpoint = `${ajaxUrl}?action=coc_getPermanentOrderSlots&x=${state.coordinates.x}&y=${state.coordinates.y}&address=${state.coordinates.address}`;
				}

				axios({
					method: "POST",
					headers: {
						"X-Requested-With": "XMLHttpRequest",
						"Content-Type": "text/html",
						charset: "utf-8",
					},
					url: endpoint,
				})
					.then((res) => {
						let success, slots;
						if (res.data.slot_service === "office-core") {
							success = res.data.success;
							slots = res.data.slots;
						} else {
							success = res.data.success;
							slots = res.data.data;
						}
						if (success === false || !slots) {
							throw new Error(
								`Failed getting slots from 
							${res.slot_service === "office-core" ? "office-core" : "quattro-shipping"}
							api`
							);
						}
						try {
							window.dataLayer.push({
								event: "ga_event",
								category: "checkout",
								action: "get_slots",
								label: "success",
							});
						} catch (err) {}
						commit("setShipSlots", slots);
					})
					.catch((e) => console.log(e));
				return;
			}

			// Handle regular case
			let endpoint = `${ajaxUrl}?getSlotForCity&id=${city_id}&orderAs=${orderAsEmail}&slot_index=${JSON.stringify(
				include_slot
			)}`;

			if (slot_service === "office-core") {
				endpoint = `${ajaxUrl}?action=coc_getSlots&x=${state.coordinates.x}&y=${state.coordinates.y}&address=${state.coordinates.address}`;
			}
			axios({
				method: "POST",
				headers: {
					"X-Requested-With": "XMLHttpRequest",
					"Content-Type": "text/html",
					charset: "utf-8",
				},
				url: endpoint,
			})
				.then((res) => {
					let success, slots;
					if (res.data.slot_service === "office-core") {
						success = res.data.success;
						slots = res.data.slots;
					} else {
						success = res.data.success;
						slots = res.data.data;
					}
					if (success === false || !slots) {
						throw new Error(
							`Failed getting slots from 
							${res.slot_service === "office-core" ? "office-core" : "quattro-shipping"}
							api`
						);
					}
					try {
						window.dataLayer.push({
							event: "ga_event",
							category: "checkout",
							action: "get_slots",
							label: "success",
						});
					} catch (err) {}
					commit("setShipSlots", slots);
				})
				.catch((e) => {
					try {
						window.dataLayer.push({
							event: "ga_event",
							category: "checkout",
							action: "get_slots",
							label: "failed",
						});
					} catch (err) {}

					Vue.prototype.$modal.show("office-core-slots-failed");
				});
		}

		return;
	},
	getCategories({ commit }) {
		commit("setCategories", JSON.parse(wpData.all_categories));
		return;
		/* axios({
           method: "GET",
           url: wpData.all_categories,
           headers: {
             "X-Requested-With": "XMLHttpRequest"
           }
         }).then(response => {
           commit("setCategories", response.data);
         }); */
	},
	weightAndQuantityPopup({ commit, state }, product) {
		if (state.userLogged || state.weightAndQuantityPopupShown) {
			return;
		}
		if (product.type === "both") {
			Vue.prototype.$modal.show("weight-and-quantity");
			commit("setWeightAndQuantityShown");
		}
	},
	incrementProduct(context, [productObj]) {
		if (typeof window.lastTimeout !== "undefined") {
			clearTimeout(window.lastTimeout);
		}
		var product = productObj;
		context.state.lastProductId = productObj;
		context.state.showLastProduct = true;
		window.lastTimeout = setTimeout(function () {
			context.state.showLastProduct = false;
		}, 2000);
		if (product.selected === "kg") {
			product.quantity = product.quantity + 0.5;
		} else {
			product.quantity++;
		}

		context.state.changeInCart = true;
		context.commit("updateCart", {
			product,
		});

		if (context.state.permOrderNew) {
			context.dispatch('addToPermanent', product);
		}
	},
	decrementProduct({ commit }, [productObj]) {
		var product = productObj;

		if (product.selected == "kg") {
			product.quantity = parseFloat(product.quantity) - 0.5;
		} else {
			product.quantity--;
		}
		if (product.quantity <= 0) product.quantity = 0;
		commit("updateCart", {
			product,
		});

		// if (context.state.permOrderNew) {
		// 	context.dispatch('removeFromPermanent', product);
		// }
	},
	removeProduct({ commit }, [productObj, isFav]) {
		const product = productObj;
		product.quantity = 0;
		commit("updateCart", {
			product,
		});
	},
	firstTime(context) {
		if (!context.state.userLogged && !context.state.city) {
			Vue.prototype.$modal.show("delivery");
		}
		return;
	},
	updateCart(context, [productObj, is_edit]) {
		const product = productObj;
		if (typeof is_edit == "undefined") {
			is_edit = false;
		}

		if (!product.instock) {
			if (!context.state.outOfStockCart.includes(product)) {
				context.state.outOfStockCart.push(product);
			}
			return;
		}
		if (typeof product != "undefined") {
			product.quantity = productObj.quantity;
			context.commit("updateCart", {
				product,
				is_edit,
			});
			return;
		}
	},
	selectType({ commit }, [productObj, selectedType]) {
		const product = productObj;
		product.selected = selectedType;
		if (product.selected !== "kg") {
			if (product.quantity < 1) {
				product.quantity = 1;
			}
			product.quantity = parseInt(product.quantity);
		}
		commit("updateCart", {
			product,
		});
	},
	clarCart({ commit }) {
		commit("clearCart");
	},
	openPopupProduct(context, [productObj, catId, productIndex]) {
		return new Promise((resolve, reject) => {
			Vue.prototype
				.$ajax({
					method: "GET",
					url: local_cache + "products/" + productObj.id + ".json",
					//crossDomain: true,
				})
				.then((response) => {
					let p = response.data;
					p.cross_sell_ids = [];
					if (typeof productIndex != "undefined") {
						p.index = productIndex;
					}
					context.commit("setProductPop", p);
					resolve();
				})
				.catch((e) => {
					reject();
				});
		});
	},
	clearProductPop({ commit }) {
		commit("ClearProductPop");
	},
	getProductById(context, productId) {
		var id = parseInt(productId);
		var product = context.state.products.find((p) => p.id === id);

		if (product) {
			return product;
		}
		var out = context.state.outOfStock.find((p) => p.id === id);
		return out;
	},
	addToPermanent(context, product) {
		var findInPermenant = context.state.permanentproducts.find((p) => p.id == product.id);
		if (typeof findInPermenant != "undefined") {
			return;
		}
		if (product.selected === "kg") {
			product.quantity = product.quantity == 0 ? 0.5 : product.quantity;
		} else {
			product.quantity = product.quantity == 0 ? 1 : product.quantity; // = product.quantity;
		}
		context.commit("hideAlert", true);
		context.commit("updateCart", { product: product });
		context.commit("setPermenant", product);
		context.commit("hideAlert", false);
	},
	removeFromPermanent(context, product) {
		var findInPermenant = context.state.permanentproducts.find((p) => p.id === product.id);
		product.quantity = 0;
		if (typeof findInPermenant != "undefined") {
			let indexOfProduct = context.state.permanentproducts.indexOf(product);
			context.commit("removePermenant", indexOfProduct);
			context.commit("updateCart", { product: product });
		}
		return;
	},
	updatePermanentOrder(context, products) {
		console.log(products);
		return new Promise((resolve, reject) => {
			let formData = new FormData();
			formData.append("action", "update_perm_products");
			formData.append("order_id", context.state.permOrder.order_id);
			formData.append("products", products);
			Vue.prototype.$ajax
				.post(ajaxUrl, formData)
				.then((res) => {
					console.log(res);
					if (res.data.success) {
						context.commit("setPermOrderEdit", false);
						context.commit("setPermOrder", res.data.data);
					} else {
						context.commit("setPermOrder", false);
					}
					resolve();
				})
				.catch((e) => {
					reject(e);
				});
		});
	},
	userLogout(context) {
		context.state.userLoggedInfo = "";
		context.state.userLogged = false;
		localStorage.removeItem("user_info");

		const refresh = document.cookie.includes("impersonated_by");
		router.push("/");

		axios({
			method: "POST",
			url: homeUrl + "?logout",
			headers: {
				"X-Requested-With": "XMLHttpRequest",
			},
		})
			.then((response) => {
				// ZZZ
				context.commit("clearUser");
				context.state.permenantOrderEdit = false;
				context.state.permanentproducts = [];
				context.state.added = [];
				context.state.storedFavs = [];
				localStorage.removeItem("fav_products");
				localStorage.removeItem("carmella-PermenantOrderEdit");
				localStorage.removeItem("perment_orders");

				// Clear 'has order available to edit state and local storage'
				localStorage.removeItem("carmella-hasEdit");
				context.state.hasOrderEdit = false;
				if (refresh) {
					location.reload();
				}
			})
			.catch((e) => console.log(e));
	},
	checkCity(context, city) {
		return new Promise((resolve, reject) => {
			if (city == "יהוד-מונוסון") {
				city = "יהוד";
			}
			const find = context.state.cities.find((c) => c.city_name == city);
			if (typeof find != "undefined") {
				resolve(true);
			}
			reject(false);
		});
	},
	setCity({ commit }, city) {
		commit("setCity", city);
	},
	getLastOrder(context) {
		context.commit("clearCart");
		axios({
			method: "GET",
			url: ajaxUrl + "?action=getLastOrder",
		})
			.then((res) => {
				if (res.data) {
					res.data.forEach((elem) => {
						const product = context.state.products.find((p) => p.id == elem.id);
						product.quantity = elem.quantity;
						product.selected = elem.type;
						context.dispatch("updateCart", [product]);
					});
				}
			})
			.catch((e) => console.log(e));
	},
	changeOrderStatus(context, [status, order_id]) {
		context.state.permOrder.state = status;
		axios({
			method: "POST",
			url: homeUrl + "?updateOrderStatus&status=" + status + "&order_id=" + order_id,
		})
			.then((res) => {
				console.log(res);
			})
			.catch((e) => console.log(e));
	},
	saveOrderStatus(context, [status, order_id]) {
		context.state.permOrder.state = status;
		axios({
			method: "POST",
			url: homeUrl + "?saveOrderStatus&status=" + status + "&order_id=" + order_id,
		})
			.then((res) => {
				if (res.data.success) {
					axios
						.get(wpData.ajax_url + "?action=getPermenantOrders")
						.then((response) => {
							if (typeof response.data.data == "object") {
								context.commit("setPermOrder", response.data.data);
							} else {
								context.commit("setPermOrder", false);
							}
						})
						.catch((e) => console.log(e));
				}
			})
			.catch((e) => console.log(e));
	},
	updateProducts(context) {
		let cart = context.state.added;
		if (cart.length > 0) {
			cart.forEach((item, index) => {
				axios({
					method: "POST",
					url: homeUrl + "ajax.php",
					params: {
						getProductById: "",
						id: item.id,
					},
				})
					.then((res) => {
						context.state.added[index].price = res.data.price;
					})
					.catch((e) => console.log(e));
			});
		}
	},
	initToolTip(context) {
		//tooltip
		var mouseLeaveTimer;
		$(".hasTooltip:not(.initialized)")
			.not(".cartTip")
			.tooltip({
				create: function (event, ui) {
					$(event.target).addClass("initialized");
				},
				position: {
					my: "center bottom-10",
					at: "center top",
					using: function (position, feedback) {
						$(this).css(position);
						$("<div>")
							.addClass("arrow")
							.addClass(feedback.vertical)
							.addClass(feedback.horizontal)
							.appendTo(this);
					},
				},
				open: function () {
					// make sure all other tooltips are closed when opening a new one
					// $(".hasTooltip")
					//   .not(this)
					//   .tooltip("close");
				},
			})
			.on("mouseleave", function (e) {
				var that = this;
				// close the tooltip later (maybe ...)
				mouseLeaveTimer = setTimeout(function () {
					$(that).tooltip("close");
				}, 100);
				// prevent tooltip widget to close the tooltip now
				e.stopImmediatePropagation();
			})
			.on("click", function (e) {
				var that = this;
				var opened_tooltip = $(this).attr("aria-describedby");

				if (typeof opened_tooltip != "undefiend") {
					return;
				}

				$(that).tooltip("close");

				// close the tooltip later (maybe ...)

				// prevent tooltip widget to close the tooltip now
			});

		$(document).on("mouseenter", ".ui-tooltip", function (e) {
			// cancel tooltip closing on hover
			clearTimeout(mouseLeaveTimer);
		});
		$(document).on("mouseleave", ".ui-tooltip", function () {
			// make sure tooltip is closed when the mouse is gone
			$(".hasTooltip").tooltip("close");
		});
		$(".hasTooltip.cartTip:not(.initialized)")
			.tooltip({
				create: function (event, ui) {
					$(event.target).addClass("initialized");
				},
				position: {
					//   my: 'left bottom', at: 'right-50% center',
					my: "left bottom",
					at: "right-25 center-5",
					using: function (position, feedback) {
						$(this).css(position);
						$("<div>")
							.addClass("arrow")
							.addClass("center")
							.addClass(feedback.vertical)
							.addClass(feedback.horizontal)
							.appendTo(this);
					},
				},
			})
			.on("tooltipopen", function (e, ui) {
				var topOfToolTip = ui.tooltip.offset().top;
				var elem = $(e.originalEvent.target);
				ui.tooltip.addClass("cartToolTip");
				$(ui.tooltip).css({ left: "400px!important" });
			})
			.on("mouseleave", function (e) {
				var that = this;
				// close the tooltip later (maybe ...)
				mouseLeaveTimer = setTimeout(function () {
					$(that).tooltip("close");
				}, 100);
				// prevent tooltip widget to close the tooltip now
				e.stopImmediatePropagation();
			});

		$(document).on("mouseenter", ".ui-tooltip", function (e) {
			// cancel tooltip closing on hover
			clearTimeout(mouseLeaveTimer);
		});
		$(document).on("mouseleave", ".ui-tooltip", function () {
			// make sure tooltip is closed when the mouse is gone
			$(".hasTooltip").tooltip("close");
		});
	},
	sendCartToServer(context) {
		clearTimeout(context.state.sendingCart);
		context.commit(
			"sendingCart",
			setTimeout(function () {
				context.dispatch("sendCartToServerAction");
			}, 2000)
		);
	},
	sendCartToServerAction(context) {
		if (context.state.sendingCart !== false) {
			Vue.prototype.$ajaxController.abort();
			Vue.prototype.$ajaxController = new AbortController();
		}

		context.commit("sentCart", false);

		let formData = new FormData();
		formData.append("action", "sendCart");
		formData.append("products", context.getters.cartJSON);

		Vue.prototype
			.$ajax({
				method: "POST",
				data: formData,
				signal: Vue.prototype.$ajaxController.signal,
			})
			.then(() => {
				context.commit("sendingCart", false);
				context.commit("sentCart", true);
				localStorage.setItem("last_sent_cart_time", new Date().toJSON());
			})
			.catch((e) => {
				context.commit("sendingCart", false);
				console.log(e);
			});
	},
	updateCartFromServer(context) {
		return axios({
			method: "POST",
			headers: {
				"X-Requested-With": "XMLHttpRequest",
				"Content-Type": "text/html",
				charset: "utf-8",
			},
			url: ajaxUrl + "?action=getStoredCart",
		})
			.then((res) => {
				if (res.data.length > 0) {
					res.data.forEach((product) => {
						context.commit("updateCart", { product: product, is_edit: false, onPageLoad: true });
					});
					context.state.showCartRecoveredNotice = true;
				}
			})
			.catch((e) => console.log(e));
	},
	clearCartFromServer(context) {
		return axios({
			method: "POST",
			headers: {
				"X-Requested-With": "XMLHttpRequest",
				"Content-Type": "text/html",
				charset: "utf-8",
			},
			url: ajaxUrl + "?action=clear_server_cart",
		})
			.then((res) => res)
			.catch((e) => console.log(e));
	},
	checkOrderEdit(context, server_update) {
		if (wpData.emergency_mode.comax) {
			return;
		}
		if (server_update) {
			axios({
				method: "POST",
				headers: {
					"X-Requested-With": "XMLHttpRequest",
					"Content-Type": "text/html",
					charset: "utf-8",
				},
				url: homeUrl + "?hasEdit",
			})
				.then((res) => {
					context.commit("setHasOrderEdit", res.data.success);
				})
				.catch((e) => console.log(e));
		} else {
			context.commit("setHasOrderEdit", wpData.user.has_editable_order);
		}
	},
	setInApp({ commit }) {
		let inapp_counter = 0;
		let inapp_interval = setInterval(function () {
			inapp_counter++;
			if (typeof INAPP_USER_DEVICE !== "undefined") {
				commit("setInApp", true);
				clearInterval(inapp_interval);
			}
			if (inapp_counter >= 3) {
				clearInterval(inapp_interval);
			}
		}, 1000);
	},
	applyBogoSale(context, sale) {
		let buy_product;
		let total_amount = 0;

		sale.product_buy.map(function (p) {
			let product = context.state.added.find((pr) => pr.id === p);
			if (typeof product != "undefined") {
				buy_product = product;
				//buy_product.gotGiftProduct = false;
				// total_amount +=
				// 	sale.type === "qty"
				// 		? parseFloat(product.quantity)
				// 		: parseFloat(product.price) * parseFloat(product.quantity);

				if (sale.type === "qty") {
					total_amount += parseFloat(product.quantity);
				} else {
					if (total_amount === 0) {
						total_amount = parseFloat("0");
					}
					if ((product.type === "both" || product.type === "unitaskg") && product.selected === "unit") {
						total_amount += Number(
							parseFloat(product.quantity * product.weight * product.price * product.divide_by).toFixed(2)
						);
					} else {
						total_amount += Number((parseFloat(product.price) * parseFloat(product.quantity)).toFixed(2));
					}
				}
			}
		});
		if (buy_product) {
			buy_product.gotGiftProduct = false;
		}

		if (
			(sale.type === "qty" && total_amount >= parseFloat(sale.amount)) ||
			(sale.type === "price" && total_amount >= parseFloat(sale.amount))
		) {
			let amount_free_product = Math.floor(total_amount / parseFloat(sale.amount));
			let got_free_product = sale.repeat
				? total_amount % parseFloat(sale.amount)
				: total_amount < parseFloat(sale.amount);

			if (!got_free_product) {
				buy_product.gotGiftProduct = true;
			}

			this.getters
				.getProductById(sale.product_get)
				.then((product) => {
					if (typeof product === "undefined") {
						return;
					}
					let find = context.state.added.find((pr) => pr.id === product.id);
					if (find) {
						if (!sale.repeat) {
							return;
						}
						// console.log(find.quantity, amount_free_product);
						find.giftedProduct = amount_free_product;
						if (find.quantity < amount_free_product) {
							// console.log("buy_product", buy_product);
							context.dispatch("incrementProduct", [find]);
						} else if (find.quantity > amount_free_product) {
							context.dispatch("decrementProduct", [find]);
						}
					} else {
						product.giftedProduct = amount_free_product;
						product.oldprice = 0;
						context.dispatch("incrementProduct", [product]);
					}
				})
				.catch((e) => {
					console.log("bogo sales error", e);
				});
		} else {
			this.getters
				.getProductById(sale.product_get)
				.then((product) => {
					let find = context.state.added.find((pr) => pr.id === product.id);
					if (find) {
						context.dispatch("decrementProduct", [find]);
					}
				})
				.catch((e) => {
					console.log("bogo sales error", e);
				});
		}
	},
	resetCashbackPoints(context) {
		context.commit("resetUsedCashbackPoints");
	},
	syncCashbackPointsComax(context) {
		if (wpData.emergency_mode.comax) {
			console.warn("-- COMAX EMERGENCY MODE --");
			return;
		}
		Vue.prototype.$ajax
			.get(ajaxUrl + "?action=sync_comax_points")
			.then((resposne) => {
				if (resposne.data.success) {
					context.state.cashback.points = resposne.data.data;
					context.dispatch("resetCashbackPoints");
				}
			})
			.catch((e) => {
				console.log(e);
			});
	},
	updateUserInfo(context) {
		axios({
			method: "GET",
			url: ajaxUrl + "?action=isUserLogged",
		})
			.then((resposne) => {
				if (resposne.data.success) {
					var user = resposne.data.data;
					context.commit("setUserInfo", user);
				} else {
					context.commit("clearUser");
				}
			})
			.catch((e) => console.log(e));
	},
	recipes_ai(context) {
		clearTimeout(context.state.sendingCartToRecipeBot);
		context.commit(
			"sendingCartToRecipeBot",
			setTimeout(function () {
				axios({
					method: "POST",
					url: "https://carmella.azurewebsites.net/match_recipes/",
					headers: {
						"Content-Type": "application/json",
					},
					data: {
						cart_id: Date.now(),
						user: context.state.userLoggedInfo,
						items: context.state.added,
					},
				})
					.then((res) => {
						console.log("match_recipes", res);
						if (res.data.success) {
						}
					})
					.catch((e) => console.log("match_recipes error", e));
			}, 2000)
		);
	},
};

export default actions;
